import { ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const projectDeployApi = {
  // 작품 배포 리스트
  read: () =>
    ifyouApi
      .get(`deploy/project-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
